import { User } from "lucide-react";
import type { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useOrganization } from "../../../shared/store/organizationStore";
import { MessageSenderAvatar } from "./MessageSenderAvatar";
import { OrganizationAvatar } from "./OrganizationAvatar";

interface ChatRoomAvatarProps {
  user?: TellescopeModelFromName<"users">;
}

// Room-list avatar: the care-team user's avatar when they've opted in, else the
// organization's icon, else the generic placeholder (kept for list alignment).
export const ChatRoomAvatar = ({ user }: ChatRoomAvatarProps) => {
  const organization = useOrganization();

  if (user && user.portalSettings?.showAvatar === true) {
    return <MessageSenderAvatar user={user} className="h-10 w-10" />;
  }

  if (organization?.faviconURL) {
    return <OrganizationAvatar organization={organization} className="h-10 w-10" />;
  }

  return (
    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
      <User className="h-5 w-5 text-primary" />
    </div>
  );
};
